// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconInfoCircle = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M12 19a7 7 0 100-14 7 7 0 000 14m9-7a9 9 0 11-18 0 9 9 0 0118 0" />,
    <path fillRule="evenodd" d="M13 10v7h-2v-7z" />,
    <path d="M13 9h-2V7h2z" />
  );
export default SvgIconInfoCircle;
